import script from "./activityDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./activityDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./activityDetailPage.vue?vue&type=style&index=0&id=b5cec38c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5cec38c"]])

export default __exports__